<template>
    <requisicao-form
        v-if="requisicao"
        operacao="A"
        @salvar="salvar($event)"
        :errosPai="erros"
        :requisicao="requisicao"
        :naoPermiteAtualizar="naoPermiteAtualizar"
        :rota-listagem="rotaListagem"
        :rota-detalhar="rotaDetalhar"
    ></requisicao-form>
</template>
<script>
import RequisicaoForm from './RequisicaoForm'
import RequisicoesServicos from './RequisicoesServicos'

export default {
    data() {
        return {
            erros: [],
            requisicao: null,
            naoPermiteAtualizar: false,
            rotaDetalhar: this.$route.query.rotaDetalhar || null,
            rotaListagem: this.$route.query.rotaListagem || null
        }
    },

    mounted() {
        this.obterRequisicao()
    },

    methods: {
        obterRequisicao() {
            this.$store.dispatch('addRequest')
            RequisicoesServicos.obterPorId(
                this.$route.params.idRequisicao
            ).then((response) => {
                if (response) {
                    if (response.success) {
                        this.requisicao = response.data
                    } else {
                        this.erros = ['Erro ao obter requisição']
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },


        salvar(requisicao) {
            this.$store.dispatch('addRequest')
            requisicao.idRequisicao = this.$route.params.idRequisicao
            RequisicoesServicos.atualizarRequisicao(requisicao).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Registro salvo com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.toDetalhar()
                            this.$store.dispatch('setRecarregar', true)
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        toDetalhar() {
            this.$router.push({
                name: this.rotaDetalhar,
                params: {
                    requisicaoId: this.$route.params.idRequisicao,
                },
                query: {
                    rotaDetalhar: this.rotaDetalhar,
                    rotaListagem: this.rotaListagem,
                }
            })
        }
    },

    components: {
        RequisicaoForm
    }
}
</script>